import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

export default function AnimBadge({
  title,
  message,
  annotation,
  onClose,
}) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const frame = requestAnimationFrame(() => setVisible(true));
    return () => cancelAnimationFrame(frame);
  }, []);

  const containerStyle = {
    position: "relative",
    padding: "14px 18px 16px",
    borderRadius: "18px",
    width: "250px",
    minHeight: "110px",
    background: "linear-gradient(200deg, #0ea5e9, #22d3ee, #38bdf8)",
    color: "#fff",
    boxShadow: "0 18px 40px rgba(14, 165, 233, 0.4)",
    overflow: "hidden",
    transform: visible ? "translateY(0) scale(1)" : "translateY(12px) scale(0.9)",
    opacity: visible ? 1 : 0,
    transition: "all 380ms cubic-bezier(0.22, 1, 0.36, 1)",
    fontFamily: "inherit",
  };

  const glowStyle = {
    position: "absolute",
    inset: "-40%",
    background:
      "radial-gradient(circle, rgba(255,255,255,0.4) 0%, rgba(255,255,255,0) 60%)",
    animation: "animBadgeGlow 3s ease-in-out infinite",
    pointerEvents: "none",
  };

  const labelStyle = {
    position: "relative",
    textTransform: "uppercase",
    fontSize: "11px",
    letterSpacing: "0.08em",
    opacity: 0.85,
  };

  const messageStyle = {
    position: "relative",
    fontSize: "34px",
    fontWeight: 700,
    lineHeight: 1.1,
    marginTop: "8px",
    fontVariantNumeric: "tabular-nums",
    textShadow: "0 0 14px rgba(255,255,255,0.35)",
    animation: "animBadgeShimmer 2.2s ease-in-out infinite",
  };

  const annotationStyle = {
    position: "relative",
    fontSize: "12px",
    marginTop: "6px",
    opacity: 0.92,
  };

  const closeButtonStyle = {
    position: "absolute",
    top: "8px",
    right: "8px",
    border: "none",
    width: "26px",
    height: "26px",
    borderRadius: "50%",
    cursor: "pointer",
    background: "rgba(8, 15, 23, 0.25)",
    color: "#fff",
    fontSize: "16px",
    lineHeight: "26px",
  };

  return (
    <div style={containerStyle}>
      {onClose ? (
        <button
          type="button"
          aria-label="Masquer ce badge"
          style={closeButtonStyle}
          onClick={onClose}
        >
          ×
        </button>
      ) : null}
      <div style={glowStyle} />
      <div style={labelStyle}>{title}</div>
      <div style={messageStyle}>{message}</div>
      {annotation ? <div style={annotationStyle}>{annotation}</div> : null}
      <style>
        {`@keyframes animBadgeGlow {
            0%,100% { transform: scale(0.9); opacity: 0.45; }
            50% { transform: scale(1.1); opacity: 0.9; }
        }
        @keyframes animBadgeShimmer {
            0%,100% { text-shadow: 0 0 14px rgba(255,255,255,0.35); }
            50% { text-shadow: 0 0 24px rgba(255,255,255,0.85); }
        }`}
      </style>
    </div>
  );
}

AnimBadge.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  annotation: PropTypes.string,
  onClose: PropTypes.func,
};

AnimBadge.defaultProps = {
  annotation: "",
  onClose: null,
};
